import { ComponentChildren } from "preact";
import { Field } from "./Field.tsx";
import { TextareaField } from "./TextareaField.tsx";
import { useSignal } from "@preact/signals";

interface Web3ContactFormProps {
  children: ComponentChildren;
  title: string;
  emailSubject: string;
  /** Optional: From Name you want to see in the email. Default is "Notifications". you can overwrite here */
  fromName?: string;
  /** Optional: To send the form submission as CC email */
  ccEmail?: string;
}

const accessKey = 'YOUR_ACCESS_KEY_HERE';

export function Web3ContactForm({ title, children, emailSubject, fromName, ccEmail }: Web3ContactFormProps) {
  const loading = useSignal(false);
  const errorMessage = useSignal("");
  const textMessage = useSignal("")

  const onSubmit = async (e: Event) => {
    e.preventDefault();

    const form = e.currentTarget as HTMLFormElement;
    const formData = new FormData(form);

    formData.append("access_key", accessKey);

    if (emailSubject) formData.append("subject", emailSubject);
    if (fromName) formData.append("from_name", fromName);
    if (ccEmail) formData.append("ccemail", ccEmail);

    loading.value = true;
    errorMessage.value = "";
    textMessage.value = "";

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData
      });

      const data = await response.json();

      if (data.success) {
        textMessage.value = "Message sent successfully!";
        form.reset();
      } else {
        console.log("Error", data);
        errorMessage.value = data.message ?? "Network error. Please try again later.";
      }

    } catch (err) {
      console.error(err);
      errorMessage.value = "Network error. Please try again later.";
    } finally {
      loading.value = false;
    }
  }

  return <div class="contact-form" style={{ maxWidth: "600px" }}>
    <div className="chasing-border">
      <div className="frame">
        <h2>{title}</h2>

        {children}

        <form method="POST" onSubmit={onSubmit}>
          <div>
            <Field type="text" name="name" label="Name" required />
            <Field type="text" name="company" label="Company" />
          </div>
          <div>
            <Field type="email" name="email" label="Email" required />
            <Field type="phone" name="phone" label="Phone" />
          </div>
          <div class="bottom-part" style={{ maxWidth: "100%" }}>
            <div style={{ height: 0, width: 0, position: "absolute", overflow: "hidden" }} >
              <input type="checkbox" name="botcheck" id="" style="display: none;" />
            </div>
            <div>
              <TextareaField
                name="message"
                label="Message"
                rows={10}
                cols={47}
                required
                minlength={10}
              />
            </div>
            <div class="submit">
              <button type="submit" class="cta-button" disabled={loading.value}>
                {loading.value ? "Sending…" : "Submit"}
              </button>
              {loading.value && <span class="loader"></span>}
              {errorMessage.value && (
                <span class="error-message">{errorMessage.value}</span>
              )}
              {textMessage.value && (
                <span class="text-message">{textMessage.value}</span>
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>;
}